import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageRowView } from '@/components/tiptap-image-row-view';

type ContentImage = { src: string; alt?: string };

/** A non-editable, two-column image block stored in the Tiptap master layout. */
export const ImageRow = Node.create({
  name: 'imageRow',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      images: {
        default: [] as ContentImage[],
        renderHTML: () => ({}),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="image-row"]',
        getAttrs: element => {
          const rawImages = (element as HTMLElement).dataset.images;
          if (!rawImages) return false;
          try {
            const images = JSON.parse(rawImages) as unknown;
            return Array.isArray(images) && images.length === 2 ? { images } : false;
          } catch {
            return false;
          }
        },
      },
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageRowView);
  },

  renderHTML({ HTMLAttributes, node }) {
    const images = node.attrs.images as ContentImage[];
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'image-row',
        'data-type': 'image-row',
        'data-images': JSON.stringify(images),
      }),
      ...images.map(image => ['img', { src: image.src, alt: image.alt ?? '' }]),
    ];
  },
});
